import { Users } from 'lucide-react';
import type { ModuleMeta } from '../types';

export const meta: ModuleMeta = { id: 'users', label: 'Users', route: '/users', icon: Users };
